import React, { useEffect } from 'react';
import { ConfContainerStyled } from './styled';
export function ConfContainer({ children }) {
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'visible';
        };
    }, []);
    return React.createElement(ConfContainerStyled, null, children);
}
